@if ($model() != null) {
    <div cdkDrag #elem
         class="shadow-sm available-flow-object flow-object-type {{FlowObjectTypeClassName.get(+$model().typeId)}}"
         matTooltipPosition="above"
         [class.disabled]="$isUniqueTaskDisabled() && !$isReadOnlyMode()"
         [matTooltip]="$model().name"
         [matTooltipDisabled]="!isOverflown(elem)"
         [cdkDragDisabled]="$isReadOnlyMode() || $isUniqueTaskDisabled()"
         [attr.data-type]="$model().typeId"
         (click)="clickEvent()"
         (keyDown)="clickEvent()"
         (cdkDragStarted)="dragStarted($event, true)"
         (cdkDragEnded)="dragEnded($event)"
         (cdkDragMoved)="dragMoved($event)"
    >
        <div class="flow-object-body-container" #flowObjectBodyContainerRef>
            <span class="flow-object-body">{{$model().name}}</span>
        </div>

        @if (!$isReadOnlyMode() && !$isUniqueTaskDisabled()) {
            <i class="select fas fa-angle-double-right"></i>
        }

        <div class="task-icon-container">
            @switch ($model().typeId) {
                @case (FlowObjectType.StartForm) {
                    <i class="icon fas fa-file-alt"></i>
                }
                @case (FlowObjectType.FinishContent) {
                    <i class="icon fas fa-file-alt"></i>
                }
                @case (FlowObjectType.StartInboundApi) {
                    <i class="icon fas fa-external-link-square-alt"></i>
                }
                @case (FlowObjectType.TaskForward) {
                    <i class="icon fas fa-paper-plane"></i>
                }
                @case (FlowObjectType.TaskAcknowledge) {
                    <i class="icon fas fa-check"></i>
                }
                @case (FlowObjectType.TaskMidwayOutboundApi) {
                    <i class="icon fas fa-external-link-alt"></i>
                }
                @case (FlowObjectType.FinishOutboundApi) {
                    <i class="icon fas fa-external-link-alt"></i>
                }
                @case (FlowObjectType.TaskRegisterProcess) {
                    <i class="icon fas fa-suitcase"></i>
                }
                @case (FlowObjectType.TaskDispatchProcess) {
                    <i class="icon fas fa-forward"></i>
                }
                @case (FlowObjectType.TaskAddToProcess) {
                    <i class="icon fas fa-file-import"></i>
                }
                @case (FlowObjectType.GatewayApprove) {
                    <i class="icon fas fa-thumbs-up"></i>
                }
                @case (FlowObjectType.GatewayRules) {
                    <i class="icon fas fa-gavel"></i>
                }
                @case (FlowObjectType.GatewayPaths) {
                    <i class="icon fas fa-random"></i>
                }
                @case (FlowObjectType.Finish) {
                    <i class="icon fas fa-stop-circle"></i>
                }
            }
        </div>

        <div class="task-category-container">
            @switch ($availableTaskType()) {
                @case (AvailableFlowObjectType.Starting) {
                    <span>Início</span>
                }
                @case (AvailableFlowObjectType.Gateway) {
                    <span>Gateway</span>
                }
                @case (AvailableFlowObjectType.Finishing) {
                    <span>Encerramento</span>
                }
                @default {
                    <span>Geral</span>
                }
            }
        </div>
    </div>

    <popover [_popoverContent]="actionsPopoverContentTemplate" [_disabled]="!$hasGatewayPath()" #actionsMatPopoverRef></popover>
    <ng-template #actionsPopoverContentTemplate>
        <div class="wrapper available-flow-objects">
            <!-- Sequência Principal -->
            <div class="action px-2" (click)="selectFlowObject()" (keyDown)="selectFlowObject()">
                <span class="mr-2">Adicionar Tarefa à Sequência <b>Principal</b></span>
                <i class="fas fa-arrow-alt-circle-up"></i>
            </div>

            <!-- Sequência A -->
            <div class="action px-2" (click)="selectFlowObject(true, false)" (keyDown)="selectFlowObject(true, false)">
                <span class="mr-2">
                    Adicionar Tarefa à {{$firstGatewayPathName().startsWith('Sequência') ? '' : 'Sequência '}}<b>{{$firstGatewayPathName()}}</b>
                </span>
                <i class="fas fa-arrow-alt-circle-right"></i>
            </div>

            <!-- Sequência B -->
            <div class="action px-2" (click)="selectFlowObject(false, true)" (keyDown)="selectFlowObject(false, true)">
                <span class="mr-2">
                    Adicionar Tarefa à {{$secondGatewayPathName().startsWith('Sequência') ? '' : 'Sequência '}}<b>{{$secondGatewayPathName()}}</b>
                </span>
                <i class="fas fa-arrow-alt-circle-down"></i>
            </div>
        </div>
    </ng-template>
}
